/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const loading = require('components/base/loading/loading');
const { apiPath } = require('appService/api');

require('./preview.scss');

/*require('./video.css');
require('./video.js');*/

const template = require('./preview.tpl');

const moduleView = require('../viewModule/viewModule');

module.exports = {
  name: "preview",
  data() {
    return{
     searhcContent:apiPath.community.searhcTopicContent,
     detailData:{},
    isWechat: /micromessenger/.test(navigator.userAgent.toLowerCase()),
      iOS: /ip(hone|ad|od)/.test(navigator.userAgent.toLowerCase()),
      android : /android/.test(navigator.userAgent.toLowerCase()),
      isdownapp:/chargerlink/.test(navigator.userAgent.toLowerCase())
    }
  },
  ready() {
    $("body").addClass("preview");
  },

  methods: {
    initPage(){
      let _preiveObj = localStorage.getItem('_peviewObj');
      if(_preiveObj){
        this.detailData = JSON.parse(_preiveObj);
        this.$refs.loadings.hide();
        localStorage.removeItem('_peviewObj');
        return;
      }
      ajaxHttp(this.searhcContent,{
          data:{
            id:this.$route.params.id
            }
          })
          .then((rtn) => {
            this.$refs.loadings.hide();
            let data =rtn.data;
            document.title = data.title;
            this.detailData = data;

            }).catch((rtn) => {
              this.$refs.loadings.hide();
              tip(rtn.message)
          })
    },
    downApp() {
        var url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.chargerlink.teslife&g_f=991653';
        if (!this.isWechat) {
          if (this.iOS) {
            url = 'https://itunes.apple.com/us/app/id824143208';
          } else if (this.android) {
            url = 'http://www.chargerlink.com/files/android/chargerlink.apk';
          }
        }
        window.location.href = url;
    },
    formatText(text){
      return (text+'').replace(/\n/g,'<br/>')
    }
  },
  template,
  components:{
    'module-view':moduleView,
    'loading':loading
  },

  route: {
    data: function (transition) {
      document.title='详情预览';
      this.$refs.loadings.show();
      this.initPage();
      

      transition.next()
    },
    waitForData: true
  },
  destroyed:function (argument) {
    $("body").removeClass("preview");
  }
}




// WEBPACK FOOTER //
// ./src/appBackend/components/page/preview/preview/preview.js